import React from 'react';
import { HeaderGeneralPrint } from '../reports/General';
import styled from 'styled-components/macro';
import { usePage } from '../../contexts/pageContext';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import { useTranslate } from '../../contexts/languageContext';
import LogoContainer from '../../containers/Logo';
import visibilidadCamara from '../utils/VisibilidadComponentes';
import useIni from '../../hooks/useIni';
import { fmt } from '../../utils';

const TablaVotosPartidos2023 = ({ camara }) => {
    const pageState = usePage();
    const nomenclator = useNomenclator();
    const ini = useIni();
    const t = useTranslate();

    const { data: dataState } = pageState;
    const tVisiblePartido = dataState.elec === '7' && dataState.amb === '00' ? false : true;
    const {
        mostrarCandidatos,
        mostrarCargos,
        mostrarSoloCandidatosConCargo,
    } = visibilidadCamara(camara.cam, ini, dataState);

    const circuscripcion = dataState?.camaras?.[0]?.cir
    const lowerCircuscripcion = circuscripcion && Number(circuscripcion) <= 1

    const { elec, amb } = dataState

    function isFirefox() {
        return /Firefox/i.test(navigator.userAgent);
    }


    return (
        <>
            {tVisiblePartido && (
                <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: '14rem' }} >
                    {!isFirefox() && <HeaderGeneralPrint nomenclator={nomenclator} data={dataState} elec={elec} amb={amb} />}
                    <article className="votosAPartidos">
                        <div className="subHeader">{t('votosPartidos')}</div>
                        <div className="content">
                            <GridTable>
                                <GridRow style={{ fontSize: "1.4rem", fontWeight: "bold", borderBottom: "2px solid rgb(0,0,0,0.3)" }}>
                                    <GridColumn style={{ gridColumn: "span 6" }}>{t('partidosMayuscula')}</GridColumn>
                                    <GridColumn style={{ gridColumn: mostrarCargos ? "span 2" : "span 3" }}>{t('votos')}</GridColumn>
                                    <GridColumn style={{ gridColumn: mostrarCargos ? "span 2" : "span 3", textAlign: mostrarCargos ? 'center' : 'right' }}>{t('porcentaje')}</GridColumn>
                                    {mostrarCargos && <GridColumn style={{ gridColumn: "span 2", textAlign: 'right' }}>{t('curules')}</GridColumn>}
                                </GridRow>
                                {camara.partotabla.map((partido, i) => {
                                    const par = nomenclator.partidos[Number(partido.act.codpar) - 1];
                                    const nompar = par === undefined ? '' : par.nombre;
                                    const cargElectos = partido.act.cargElectos;
                                    return (
                                        <div key={partido.act.codpar} style={{ marginBottom: lowerCircuscripcion ? "3rem" : 'unset', borderBottom: "2px solid rgb(0,0,0,0.3)" }}>
                                            <GridRow style={{ alignItems: lowerCircuscripcion ? "end" : 'center' }}>
                                                <GridColumn style={{ gridColumn: "span 6" }}>
                                                    <div style={{ display: "flex", flexDirection: 'column', gap: "1rem", justifyContent: "center", alignItems: "center", fontWeight: "bold", fontSize: '1.6rem' }}>
                                                        {lowerCircuscripcion &&
                                                            <StyledLogo codpar={par.codpar} height={'50px'} width={'50px'} />
                                                        }
                                                        <span>{nompar}</span>
                                                    </div>
                                                </GridColumn>
                                                <GridColumn style={{ fontWeight: 'bold', fontSize: '1.6rem', gridColumn: mostrarCargos ? "span 2" : "span 3" }}>{fmt(partido.act.vot)}</GridColumn>
                                                <GridColumn style={{ fontWeight: 'bold', fontSize: '2rem', gridColumn: mostrarCargos ? "span 2" : "span 3", textAlign: mostrarCargos ? 'center' : 'right' }}>{partido.act.pvot}</GridColumn>
                                                {mostrarCargos && (
                                                    <GridColumn style={{ gridColumn: "span 2", textAlign: 'right' }}>
                                                        {Number(cargElectos) === 0
                                                            ? ''
                                                            : Number(partido.data.act.cargEmpatados) > 0
                                                                ? cargElectos + '*'
                                                                : cargElectos}
                                                    </GridColumn>)}
                                            </GridRow>
                                            {mostrarCandidatos &&
                                                partido.act.cantotabla?.map((candidato, index) => {
                                                    if (
                                                        !mostrarSoloCandidatosConCargo ||
                                                        (mostrarSoloCandidatosConCargo && candidato.carg === '1')
                                                    ) {
                                                        const mostrarVotos = (candidato.pref === '1') || (candidato.pref === '0' && candidato.codcan === '0');
                                                        return (
                                                            <GridRow key={candidato.codcan} className="candidato" style={{ background: index % 2 === 0 ? '#F1F3F5' : '#FFF' }}>
                                                                <GridColumn style={{ gridColumn: "span 6" }}>{candidato.nomcan + ' ' + candidato.apecan}</GridColumn>
                                                                {mostrarVotos && <>
                                                                    <GridColumn style={{ gridColumn: mostrarCargos ? "span 2" : "span 3" }}>{fmt(candidato.vot)}</GridColumn>
                                                                    <GridColumn style={{ fontWeight: 'bold', fontSize: '1.6rem', gridColumn: mostrarCargos ? "span 2" : "span 3", textAlign: mostrarCargos ? 'center' : 'right' }}>{candidato.pvot}</GridColumn>
                                                                </>}
                                                                {mostrarCargos &&
                                                                    <GridColumn className="cargos" style={{ gridColumn: "span 2", textAlign: 'right' }}>
                                                                        <ContenedorVotoProferente>
                                                                            {candidato.carg === '1' ? (
                                                                                candidato.empate === '1' ? (
                                                                                    <VotoEmpate>S/A**</VotoEmpate>
                                                                                ) : (
                                                                                    <VotoPreferente />
                                                                                )
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </ContenedorVotoProferente>
                                                                    </GridColumn>}
                                                            </GridRow>
                                                        );
                                                    } else {
                                                        return <></>
                                                    }
                                                })}
                                        </div>
                                    );
                                })}
                            </GridTable>
                        </div>
                    </article>
                </div>
            )}
        </>
    );
};

export default TablaVotosPartidos2023;


const GridTable = styled.div``
const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  align-items: center;
`
const GridColumn = styled.div`
  text-align: center;
`


const ContenedorVotoProferente = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const VotoPreferente = styled.span`
  background: black;
  height: 10px;
  width: 10px;
  display: block;
  border-radius: 50%;
`;

const VotoEmpate = styled.span`
  font-size: 13px;
  font-weight: 500;
  text-align: right;
`;

const StyledLogo = styled(LogoContainer)`
  padding: 5px;
  /* height: 50px; */
  /* height: ${({ height }) => height}; */
  width: ${({ width }) => width}; 
`;